/**
 * 验证number
 * @param num 编码
 */
export function validNumber (num) {
  return /^[0-9]+$/.test(num)
}

/**
 * 验证name
 */
export function validName (name) {
  const regEn = /[=`\\~!@&#$%^*+<>?:"{},.\\/;'[\]\s]/im
  const regCn = /[·！#&￥——：……；“”‘、，| [\]]/im
  return !(regEn.test(name) || regCn.test(name))
}
/**
 * 手机号码
 */
export function validMobile (s) {
  return /^1[3|4|5|6|7|8|9][0-9]\d{8}$/.test(s)
}

/**
 * 验证电话号码
 */
export function validTel (tel) {
  return /^1[3456789]\d{9}$/.test(tel)
}

/**
 * 验证邮箱
 */
export function validEmail (email) {
  return /^[a-zA-Z0-9-_]+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/.test(email)
}

/**
 * 验证数字字母
 */
export function validNumberalphabet (code) {
  return /^[A-Z0-9]+$/.test(code)
}

/**
 * 验证中文 2-6个汉字
 */
export function validChinese (code) {
  return /^[\u4E00-\u9FA5]{2,6}$/.test(code)
}

/**
 * 验证身份证
 */
export function validIdNo (code) {
  const _IDRe18 = /^([1-6][1-9]|50)\d{4}(18|19|20)\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
  const _IDre15 = /^([1-6][1-9]|50)\d{4}\d{2}((0[1-9])|10|11|12)(([0-2][1-9])|10|20|30|31)\d{3}$/
  // return /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/.test(code)
  return _IDRe18.test(code) || _IDre15.test(code)
}

/**
  * 时间戳转换年月日
  */
export const dateTrans = function (timestamp) {
  return new Date(timestamp).toLocaleDateString()
}

/**
  * 时间戳转换年月日时分秒
  */
export const dateTimeTrans = function (timestamp) {
  return new Date(timestamp).toLocaleString('chinese', {hour12: false}).replace(/\//g, '-')
}

// 日期转化  年龄数字
export const dateChangeNum = (str) => {
  if (!str) return ''
  let r = str.match(/^(\d{1,4})(-|\/)(\d{1,2})\2(\d{1,2})$/)
  if (r == null) return false
  let d = new Date(r[1], r[3] - 1, r[4])
  if (
    d.getFullYear() === Number(r[1]) &&
    d.getMonth() + 1 === Number(r[3]) &&
    d.getDate() === Number(r[4])
  ) {
    let Y = new Date().getFullYear()
    return Y - r[1]
  }
}

// 年龄数字   转化日期
export const numChangeDate = (num) => {
  if (!num) return ''
  let date = new Date()
  let seperator1 = '-'
  let year = date.getFullYear() - num
  let month = date.getMonth() + 1
  let strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  let currentdate = year + seperator1 + month + seperator1 + strDate
  return currentdate
}

export const dateToString = (time) => {
  var datetime = new Date()
  datetime.setTime(time)
  var year = datetime.getFullYear()
  var month = datetime.getMonth() + 1
  var date = datetime.getDate()
  // var hour = datetime.getHours()
  /* 对月 日 时 分 秒 小于10的时候的处理  --小于 10 时前面加 0 */
  if (month <= 9) {
    month = '0' + month
  }
  if (date <= 9) {
    date = '0' + date
  }
  // if (hour <= 9) {
  //   hour = '0' + hour
  // }
  // var minute = datetime.getMinutes()
  // if (minute <= 9) {
  //   minute = '0' + minute
  // }
  // var second = datetime.getSeconds()
  // if (second <= 9) {
  //   second = '0' + second
  // }
  return year + '-' + month + '-' + date
}

export const formatJsonStr = (str) => {
  if (typeof str === 'string') {
    try {
      let val = JSON.parse(str)
      if (typeof val === 'object' && val) {
        return val
      } else if (typeof val === 'number' && val) {
        return val + ''
      } else {
        return ''
      }
    } catch (e) {
      // console.warn('error：' + str + '!!!' + e)
      return str
    }
  }
  return ''
}

// 当前环境是否是开发环境
// export const IS_DEV = process.env.NODE_ENV === 'development'
// 当前环境是否是生产环境
export const IS_PROD = process.env.NODE_ENV === 'production'

// url参数转json
export const parseQueryString = function (url) {
  url = decodeURIComponent(url)
  const index = url.indexOf('?')
  let queryStr
  if (index === -1) {
    queryStr = url
  } else {
    queryStr = url.slice(index + 1)
  }
  const obj = {}
  const arr = queryStr.split('&')
  for (let item of arr) {
    const keyValue = item.split('=')
    obj[keyValue[0]] = keyValue[1]
  }
  return obj
}

// json转url参数
export const jsonTransUrl = function (objs) {
  let str = ''
  for (const k in objs) {
    if (['string', 'number'].includes(typeof objs[k])) {
      str === ''
      ? str += `${k}=${objs[k]}`
      : str += `&${k}=${objs[k]}`
    }
  }
  return str
}



// WEBPACK FOOTER //
// ./src/utils/validator.js